import { lighten, darken } from 'polished';

export default theme => ({
  logo: {
    padding: `${theme.spacing.unit * 2}px 0`,
    height: 100
  },
  megaText: {
    fontSize: '3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem'
    }
  },

  transparent: {
    opacity: 0.9,
    zIndex: 99999
  },
  errorWall: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    background: lighten(0.2, theme.palette.secondary.main)
  },

  text: {
    color: darken(0.25, theme.palette.secondary.main)
  },
  errorContainer: {
    maxWidth: '50%',
    display: 'block',
    width: '100%',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    WebkitTransform: 'translate(-50%,-50%)',
    MozTransform: 'translate(-50%,-50%)',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90%'
    }
  },
  errorThumbnail: {
    width: 50
  },
  button: {
    marginTop: theme.spacing.unit * 2
  },

  closeIcon: {
    margin: theme.spacing.unit,
    position: 'absolute',
    left: 0,
    top: 0
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },

  errorReasonText: {
    color: 'red',
    fontWeight: 700,
    margin: `${theme.spacing.unit * 3}px 0`
  }
});
